import { observable, configure, reaction } from "mobx";

import { movieModel } from "./movieModel";
import { loginModel } from "./loginModel";

export const reactiveMovieModel = observable(movieModel);
export const reactiveLoginModel = observable(loginModel);
/*
function checkMovieModelACB() {
    return reactiveMovieModel.ratings;
}
function updateMovieModelACB() {
    //
}
reaction (checkMovieModelACB, updateMovieModelACB);
*/